<template>
	<Row
		v-if="showCreateSyncedGroupSuggestion"
		class="create-synced-group-suggestion-container flex-justify-space-between flex-align-center px-2"
	>
		<Row class="flex-align-center">
			<SIcon class="mr-2" :height="18" name="create-synced-group-invite-suggestion" />
			<Row>
				<h5 class="create-text">{{ otherMatchingUsersCount }} other teammates are using {{ serviceName }}. Add one by one or</h5>
				<h5 @click="openSyncedGroupDialog" class="create-text ml-1 link">create synced group</h5>
			</Row>
		</Row>
		<div @click="close = true" class="close-group-icon hover-effect">
			<v-icon class="icon font-size-sm">mdi-close</v-icon>
		</div>
	</Row>
</template>

<script>
/* This suggestion should work when:
	1. The user is admin of account (can create a group)
	2. The flow is an experience (this way we have a context node)
	3. The context service related does not already have an existing synced group
 */
import { workflowSharedData } from '@/store/modules/workflows/getters';
import { setWorkflowShareData } from '@/store/modules/workflows/actions';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import AppDialogManagerService from '../../../components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'SyncGroupSuggestion',
	components: {},
	props: {
		workflowId: { type: Number },
	},
	methods: {
		...mapActionsShorthand({ setWorkflowShareData }),
		async openSyncedGroupDialog() {
			// do not close this shared dialog - so we will return here after creating a group;
			const res = await AppDialogManagerService.openSyncedGroupDialog({
				defaultProfileId: this.sharedData.related_credentials_id,
				defaultServiceId: this.sharedData.related_service_id,
			});
			if (res?.status === 'created') {
				this.setWorkflowShareData({ id: this.workflowId, force: true });
				this.$emit('synced-group-created', res.group.id);
			}
		},
	},
	computed: {
		...mapGettersShorthand({ workflowSharedData }),
		matchingUsersCount() {
			return this.sharedData.related_user_matching?.length || 1; // 1 = me
		},
		otherMatchingUsersCount() {
			return this.matchingUsersCount - 1;
		},
		hasRelatedSyncedGroup() {
			return this.sharedData.related_synced_groups?.length > 0;
		},
		showCreateSyncedGroupSuggestion() {
			return !this.close && this.sharedData.is_user_matching && this.matchingUsersCount > 1 && !this.hasRelatedSyncedGroup;
		},
		serviceName() {
			return this.sharedData.related_service_name;
		},
		sharedData() {
			return this.workflowSharedData(this.workflowId) || {};
		},
	},
	data() {
		return {
			close: false,
		};
	},
};
</script>

<style scoped lang="scss">
.create-synced-group-suggestion-container {
	min-height: 40px;
	border-radius: 7px;
	margin-bottom: 10px;
	background: #f7f9ff;
}
.create-text {
	color: #5c8df5;
	letter-spacing: 0px;
}
.close-group-icon {
	padding: 0 6px 2px 6px;

	border-radius: 50%;
	background-color: #f7f9ff;
	.icon {
		background-color: #f7f9ff !important;
		font-size: small;
	}
}
</style>
